<template>
  <div v-if="!loading">
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-title>نمایش نقش ها</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" class="text-left">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="hover-link mx-1"
                        color="teal"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/permission-and-role/role/setting')">mdi-cog
                </v-icon>
              </template>
              <span class="tooltip-text">تنظیمات سطح دسترسی</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon x-large class="hover-link mx-1"
                        color="success"
                        v-bind="attrs"
                        v-on="on" @click="$router.push('/permission-and-role/role/create')">mdi-plus
                </v-icon>
              </template>
              <span class="tooltip-text">ساخت نقش جدید</span>
            </v-tooltip>
          </v-col>
          <v-col cols="12">
            <v-data-table
                align="center"
                :headers="headers"
                :items="roles"
                :items-per-page="10"
                disable-sort
                hide-default-footer>
              <template
                  v-slot:[`item.operation`]="{ item }">
                <v-icon class="mx-1" color="purple" @click="$router.push('/permission-and-role/role/edit/'+item.id)">
                  mdi-pen
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "RoleIndexView",
  data() {
    return {
      loading: true,
      roles: [],
      headers: [
        {text: 'شناسه', value: 'id', align: 'center'},
        {text: 'نام', value: 'name', align: 'center'},
        {text: 'لیبل', value: 'label', align: 'center'},
        {text: 'عملیات', value: 'operation', align: 'center'},
      ],
    }
  },
  mounted() {
    this.getRoles()
  },
  methods: {
    getRoles() {
      window.axios.get('system/role/index').then((res) => {
        this.roles = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    }
  }
}
</script>

<style scoped>

</style>